import React, { useState } from 'react';
import classNames from 'classnames';
import { Status, Icon, toaster } from '@fiverr-private/fit';
import { BASE_CLASS, THEMES } from './constants';
import THEME_CONFIG from './themeConfig';
import raise from './utils/raise';
import { StatusToastInterface, StatusToastProps } from './types';
import './index.scss';

/**
 * @deprecated Please use raiseToast from @fiverr-private/toast instead.
 */
const StatusToast = ({ className, message, theme = 'success' }: StatusToastProps) => {
    const [shouldRender, setShouldRender] = useState(true);

    const onDismiss = () => setShouldRender(false);

    if (!shouldRender) {
        return null;
    }

    const { statusIcon, color } = THEME_CONFIG[theme];

    const wrapperClasses = classNames(
        BASE_CLASS,
        'active',
        `theme-${theme}`,
        className
    );

    return (
        <Status className={wrapperClasses} color={color}
            handleDismiss={onDismiss}>
            <div className="status-message">
                <Icon size={16} className="status-icon">
                    {statusIcon}
                </Icon>
                <p className="tbody-5">
                    {message}
                </p>
            </div>
        </Status>
    );
};

StatusToast.displayName = 'StatusToast';

Object.assign(StatusToast, {
    THEMES,
    LOCATIONS: toaster.LOCATIONS
});

StatusToast.raise = raise;
const StatusToastWithRaise: StatusToastInterface = StatusToast;
export default StatusToastWithRaise;
